module.exports = __webpack_public_path__ + "static/media/closed.4864f2a2.png";